import React from 'react';
import { componentService } from 'js/services/component.service';

export const GamesSearch = React.lazy(() => import(/* webpackChunkName: "games-search" */ './GamesSearch').then((module) => ({ default: module.GamesSearch })));

componentService.registerPageComponents({ 'games-search': GamesSearch });
